import Cookies from 'js-cookie'

// Token相关操作
export const tokenUtils = {
  // 设置token
  setToken(token) {
    Cookies.set('token', token, { expires: 7 })
  },
  
  // 获取token
  getToken() {
    return Cookies.get('token')
  },
  
  // 移除token
  removeToken() {
    Cookies.remove('token')
  },
  
  // 检查是否有token
  hasToken() {
    return !!Cookies.get('token')
  }
}

// 用户信息相关操作
export const userUtils = {
  // 设置用户信息
  setUserInfo(userInfo) {
    localStorage.setItem('userInfo', JSON.stringify(userInfo))
  },
  
  // 获取用户信息
  getUserInfo() {
    const userInfo = localStorage.getItem('userInfo')
    return userInfo ? JSON.parse(userInfo) : null
  },
  
  // 移除用户信息
  removeUserInfo() {
    localStorage.removeItem('userInfo')
  }
}

// 认证状态检查
export const authUtils = {
  // 检查是否已登录
  isAuthenticated() {
    return tokenUtils.hasToken() && userUtils.getUserInfo()
  },
  
  // 清除所有认证信息
  clearAuth() {
    tokenUtils.removeToken()
    userUtils.removeUserInfo()
  },
  
  // 获取认证头
  getAuthHeader() {
    const token = tokenUtils.getToken()
    return token ? { Authorization: `Bearer ${token}` } : {}
  },
  
  // 获取当前用户角色
  getUserRole() {
    const userInfo = userUtils.getUserInfo()
    return userInfo ? userInfo.role : null
  },
  
  // 检查是否是管理员
  isAdmin() {
    return this.getUserRole() === 'admin'
  },
  
  // 检查是否是编辑员
  isEditor() {
    const role = this.getUserRole()
    return role === 'editor' || role === 'admin'
  },
  
  // 检查是否是普通用户
  isViewer() {
    const role = this.getUserRole()
    return role === 'viewer' || role === 'editor' || role === 'admin'
  }
}

